import { ReactElement } from 'react';
import { IMetaLocationClosedDates, IPageLocationFields } from 'types/contentful';
import OfficeLocationCard from './OfficeLocationCard';

interface DoctorLocationsAccordianProps {
  id: string;
  locations: IPageLocationFields[];
  closedDates: IMetaLocationClosedDates | undefined;
  siteName: string;
  markerIcon: string;
}

export default function DoctorLocationsAccordian({
  locations,
  closedDates,
  siteName,
  id,
  markerIcon,
}: DoctorLocationsAccordianProps): ReactElement {
  return (
    <div id={id} className="lg:py-10">
      <h3 className="font-heading text-3xl mt-6 md:mt-0 mb-6 lg:text-4xl text-center">
        My Locations
      </h3>
      <div className="space-y-5">
        {locations.map((x, i) => (
          <OfficeLocationCard
            location={x}
            key={i}
            index={i}
            closedDates={closedDates}
            siteName={siteName}
            markerIcon={markerIcon}
          />
        ))}
      </div>
    </div>
  );
}
